export default {
  currentBuilding: {},
  cubFilter: 1,
  allCubs: []
};
